import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Style // Не забудьте этот импорт!

// 1. Создаем таблицу стилей
object AdStyles : StyleSheet() {
    val bannerContainer by style {
        width(300.px)
        height(100.percent)
        backgroundColor(Color("#f0f2f5"))

        // Теперь media работает, так как это часть CSS-класса
        media(mediaMaxWidth(800.px)) {
            self style {
                display(DisplayStyle.None)
            }
        }
    }
}

@Composable
fun YandexLeftBanner() {
    // 2. Инициализируем стили (вставляет тег <style> в DOM)
    Style(AdStyles)

    // Контейнер для баннера
    Div({
        id("yandex_rtb_R-A-18391543-1")
        // 3. Применяем класс вместо inline-стилей
        classes(AdStyles.bannerContainer)
    })

    // Логика JS остается той же
    LaunchedEffect(Unit) {
        try {
            val win = window.asDynamic()
            win.yaContextCb.push(fun() {
                win.Ya.Context.AdvManager.render(js("""
                    {
                        "blockId": "R-A-18391543-1",
                        "renderTo": "yandex_rtb_R-A-18391543-1"
                    }
                """))
            })
        } catch (e: Exception) {
            console.error("Ошибка загрузки рекламы: ", e)
        }
    }
}